import { render, staticRenderFns } from "./GruposForm.vue?vue&type=template&id=560feb92&"
import script from "./GruposForm.vue?vue&type=script&lang=js&"
export * from "./GruposForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports